import "./Home.css";
import React, { useState, useEffect } from "react";

import Schedule from "../visual/Schedule.js";

import { idRegex } from "../../js/consts.js";
import { showAlert, downloadSchedule } from "../../js/utils.js";
import { logEvent } from "../../js/analytics.js";
import { saveSchedule } from "../../js/storedSchedule.js";
import FloatingButton from "../smart/FloatingButton.js";
import { useSearchParams, useNavigate } from "react-router-dom";
import { CircularProgress } from "@mui/material";
import { useDownloadScheduleQuery } from "../../js/queryHooks.js";

const sched = {
  schedCategory: "",
  slots: [],
};

const Home = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const navigate = useNavigate();

  const gucSearchParamId = searchParams.get("id");
  const hasGucSearchParamId = !!gucSearchParamId;
  const [gucId, setGucId] = useState(gucSearchParamId || "");

  const downloadScheduleQuery = useDownloadScheduleQuery(gucSearchParamId);

  const isValidGucId = idRegex.test(gucId);
  console.log({ gucSearchParamId, downloadScheduleQuery });

  useEffect(() => {
    logEvent("page_view", { page: "home" });
  }, []);

  const onGetClick = async () => {
    if (!isValidGucId) {
      showAlert("Error", "Invalid ID provided");
      return;
    }
    navigate(`?id=${encodeURIComponent(gucId)}`);
  };

  const onSaveSchedule = () => {
    const message =
      gucSearchParamId.length > 0
        ? `Are you sure you want to save ${gucSearchParamId}'s schedule?`
        : "Are you sure you want to clear the saved schedule?";
    showAlert("Save Schedule", message, {
      showCancelButton: true,
      confirmButtonStyledText: "Yes",
      cancelButtonStyledText: "No",
    }).then((result) => {
      if (!result.isConfirmed) return;
      saveSchedule(downloadScheduleQuery.data.scheduleData);
      logEvent("saved_schedule");
      window.location.href = "/my_schedule";
    });
  };
  console.log({ downloadScheduleQuery });

  return (
    <div className="App">
      <div id="name"> GUC Schedule Viewer</div>
      <input
        id="id"
        type="text"
        placeholder="Enter GUC ID"
        onChange={(e) => setGucId(e.target.value)}
        value={gucId}
      ></input>
      <br></br>
      <button
        id="get"
        onClick={onGetClick}
        disabled={!isValidGucId || gucId === gucSearchParamId}
      >
        Load Schedule
      </button>
      <br />
      {gucSearchParamId && (
        <div style={{ color: "var(--text-color)", marginBottom: "15px" }}>
          {gucSearchParamId}'s Schedule
        </div>
      )}
      {downloadScheduleQuery.isLoading ? (
        <CircularProgress />
      ) : downloadScheduleQuery.isError ? (
        <div style={{ color: "var(--text-color)" }}>
          Error: {downloadScheduleQuery.error.message}
        </div>
      ) : downloadScheduleQuery.isSuccess ? (
        <Schedule schedule={downloadScheduleQuery.data.scheduleData} />
      ) : null}
      <FloatingButton onClick={onSaveSchedule} text="Save My Schedule" />
    </div>
  );
};
export default Home;
